let lottie_containers = document.querySelectorAll(".lottie"),
    animate = [];

lottie_containers.forEach(item => {
    const lottie_container = document.getElementById(item.id),
        //Auto animate if there is no scroll attribute
        autoplay = () => {
            let lottie_animation_settings = {
                container: lottie_container,
                renderer: "svg",
                loop: (lottie_container.hasAttribute("loop")) ? "true" : "false",
                autoplay: (lottie_container.hasAttribute("autoplay")) ? "true" : "false",
                prerender: true,
                rendererSettings: {
                    progressiveLoad: true,
                },
                path: lottie_container.getAttribute("path")
            };
            animate[lottie_container] = bodymovin.loadAnimation(lottie_animation_settings);
            animate[lottie_container].setSpeed(lottie_container.getAttribute('speed'));
        },
        //scrooll and animate when lottie is in view
        scroll_to_play = () => {
            ScrollLottie({
                container: lottie_container,
                trigger: (!lottie_container.hasAttribute("start")) ? lottie_container : lottie_container.getAttribute('start'),
                endTrigger: (!lottie_container.hasAttribute("end")) ? lottie_container : lottie_container.getAttribute('end'),
                loop: (lottie_container.hasAttribute("loop")) ? "true" : "false",
                autoplay: (lottie_container.hasAttribute("autoplay")) ? "true" : "false",
                duration: lottie_container.getAttribute('speed'),
                markers: (lottie_container.hasAttribute("marker")) ? true : false,
                path: lottie_container.getAttribute("src")
            })
        }
    //if lottie_container does not have the scroll attribute use autoplay function else us scroll_to_play
    (!lottie_container.hasAttribute("scroll")) ? autoplay() : scroll_to_play();
})

